module.exports = __webpack_public_path__ + "static/media/12UNCTAD7.0d6fbc1c.jpg";